import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../utils/api";
import "./channel.css";

export default function Channel() {
  const { channelId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const isUserPanel = location.pathname.startsWith("/user");

  const [channelData, setChannelData] = useState(null);
  const [videos, setVideos] = useState([]);
  const [posts, setPosts] = useState([]);
  const [activeTab, setActiveTab] = useState("videos");
  const [loading, setLoading] = useState(true);

  const [isEditing, setIsEditing] = useState(false);
  const [aboutText, setAboutText] = useState("");

  const [songs, setSongs] = useState([]);

  // ? NEW STATES
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [loadingSubscribe, setLoadingSubscribe] = useState(false);

  const storedUser = localStorage.getItem("user");
  const currentUser = storedUser ? JSON.parse(storedUser) : null;
  const userId = currentUser?._id;

  useEffect(() => {
    if (!channelId) return;

    const loadChannel = async () => {
      try {
         const [channelRes, postRes, songRes] = await Promise.all([
           api.get("/client/user/detailsOfChannel", {
             params: { channelId, userId, start: 1, limit: 200 },
           }),
          api.get("/client/posts/channel-posts", {
            params: { channelId },
          }),
         api.get("/client/song/songsOfChannel", {
           params: { channelId },
         }),
        ]);

        if (channelRes.data.status) {
          const allVideos = channelRes.data.detailsOfChannel || [];

          const onlyVideos = allVideos.filter(v => v.videoType === 1);
          const onlyShorts = allVideos.filter(v => v.videoType === 2);

          setChannelData({
            channelName: channelRes.data.channelName,
            channelImage: channelRes.data.channelImage,
            totalSubscribers: channelRes.data.totalSubscribers || 0,
            descriptionOfChannel:
              channelRes.data.descriptionOfChannel || "",
            videoCount: onlyVideos.length,
            shortsCount: onlyShorts.length,
          });

          setIsSubscribed(channelRes.data.isSubscribed || false);

          setVideos(allVideos);
          setAboutText(channelRes.data.descriptionOfChannel || "");
        }

        if (postRes.data.status) {
          setPosts(postRes.data.postsOfChannel || []);
        }
       if (songRes.data.status) {
         setSongs(songRes.data.songs || []);
      }

      } catch (err) {
        console.error("Channel load error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadChannel();
  }, [channelId, userId]);

  // ? SUBSCRIBE TOGGLE
  const handleSubscribe = async () => {
    if (!currentUser) {
      navigate("/login");
      return;
    }

    if (loadingSubscribe) return;
    setLoadingSubscribe(true);

    try {
      const res = await api.post(
        "/client/userWiseSubscription/subscribedUnSubscibed",
        {},
        {
          params: {
            userId: currentUser._id,
            channelId: channelId,
          },
        }
      );

      if (res.data.status) {
        setIsSubscribed(res.data.isSubscribed);

        setChannelData(prev => ({
          ...prev,
          totalSubscribers: Math.max(
           0,
          res.data.isSubscribed
          ? prev.totalSubscribers + 1
          : prev.totalSubscribers - 1
          ),}));
      } else {
        alert(res.data.message);
      }

    } catch (error) {
      console.error("Subscribe error:", error);
    }

    setLoadingSubscribe(false);
  };

  const saveAbout = async () => {
    try {
      await api.patch(
        "/client/user/updateProfile",
        { descriptionOfChannel: aboutText },
        { params: { userId: userId } }
      );

      setChannelData(prev => ({
        ...prev,
        descriptionOfChannel: aboutText,
      }));

      setIsEditing(false);
    } catch (err) {
      console.error("About update error", err);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!channelData) return <p>Channel not found</p>;

  const isOwnChannel = currentUser?.channelId === channelId;

  return (
    <div className="channel-container">

      {/* HEADER */}
      <div className="channel-header">
        <img
          src={channelData.channelImage}
          alt="channel"
          className="channel-avatar"
        />

        <div>
          <h2>{channelData.channelName}</h2>

          <div className="channel-stats">
            <span>{channelData.totalSubscribers} Subscribers</span>
            <span>{channelData.videoCount} Videos</span>
            <span>{channelData.shortsCount} Shorts</span>
            <span>{posts.length} Posts</span>
            <span>{songs.length} Songs</span>
          </div>

          {/* ? SUBSCRIBE BUTTON */}
          {!isOwnChannel && (
            <button
              className={`subscribe-btn ${isSubscribed ? "subscribed" : ""}`}
              onClick={handleSubscribe}
              disabled={loadingSubscribe}
            >
              {loadingSubscribe
                ? "Please wait..."
                : isSubscribed
                ? "Subscribed"
                : "Subscribe"}
            </button>
          )}
        </div>
      </div>

      {/* TABS */}
      <div className="channel-tabs">
        {["videos", "shorts", "posts", "songs", "about"].map(tab => (
          <button
            key={tab}
            className={activeTab === tab ? "active" : ""}
            onClick={() => setActiveTab(tab)}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>

      {/* VIDEOS */}
      {activeTab === "videos" && (
        <div className="video-grid">
          {videos
            .filter(v => v.videoType === 1)
            .map(video => (
              <div
                key={video._id}
                className="video-card"
                onClick={() =>
                  navigate(
                    isUserPanel
                      ? `/user/video/${video._id}`
                      : `/video/${video._id}`
                  )
                }
              >
                <img src={video.videoImage} alt={video.title} />
                <h4>{video.title}</h4>
                <p>{video.views || 0} views</p>
              </div>
            ))}
        </div>
      )}

      {/* SHORTS */}
      {activeTab === "shorts" && (
        <div className="shorts-grid">
          {videos
            .filter(v => v.videoType === 2)
            .map(video => (
              <div
                key={video._id}
                className="short-card"
                onClick={() =>
                  navigate(
                    isUserPanel
                      ? `/user/shorts/${video._id}`
                      : `/shorts/${video._id}`
                  )
                }
              >
                <img src={video.videoImage} alt={video.title} />
              </div>
            ))}
        </div>
      )}

      {/* POSTS */}
      {activeTab === "posts" && (
        <div className="posts-grid">
          {posts.length === 0 && <p>No posts yet</p>}
          {posts.map(post => (
            <div
              key={post._id}
              className="post-card"
              onClick={() =>
                navigate(
                  isUserPanel
                    ? `/user/post/${post._id}`
                    : `/post/${post._id}`
                )
              }
            >
              {post.media?.url && (
                <img src={post.media.url} alt="post" />
              )}
            </div>
          ))}
        </div>
      )}

{/* SONGS */}
{activeTab === "songs" && (
  <div className="songs-grid">
    {songs.length === 0 && <p>No songs yet</p>}
    {songs.map(song => (
      <div
        key={song._id}
        className="song-card"
        onClick={() =>
          navigate(
            isUserPanel
              ? `/user/song/${song._id}`
              : `/song/${song._id}`
          )
        }
      >
        {song.thumbnailUrl && (
          <img src={song.thumbnailUrl} alt={song.title} />
        )}
        <h4>{song.title}</h4>
        <p>{song.totalPlays || 0} plays</p>
      </div>
    ))}
  </div>
)}

      {/* ABOUT */}
      {activeTab === "about" && (
        <div className="about-section">
          {isEditing ? (
            <>
              <textarea
                value={aboutText}
                onChange={(e) => setAboutText(e.target.value)}
                rows={4}
                className="about-textarea"
              />
              <button className="save-btn" onClick={saveAbout}>
                Save
              </button>
            </>
          ) : (
            <>
              <p>
                {channelData.descriptionOfChannel ||
                  "No description added."}
              </p>
              {isUserPanel && (
                <button
                  className="edit-btn"
                  onClick={() => setIsEditing(true)}
                >
                  Edit
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
}